import moment from 'moment'
import { saveAs } from 'file-saver'
import { moneyFormat } from 'easyguide'

const initialState = {
  isFetching: false,
  isFetched: false,
  success: false,
  error: false,
  data: null,
  isFetchingDownload: false,
  isFetchedDownload: false,
  successDownload: false,
  errorDownload: false,
  origin: [],
  selectedOrigin: null,
  transactionType: null,
  startDate: null,
  displayStartDate: null,
  endDate: null,
  displayEndDate: null,
  summary: null
}

export const ACTION_TYPES = {
  IRRF_REQUEST: 'IRRF_REQUEST',
  IRRF_SUCCESS: 'IRRF_SUCCESS',
  IRRF_ERROR: 'IRRF_ERROR',

  IRRF_REPORT_REQUEST: 'IRRF_REPORT_REQUEST',
  IRRF_REPORT_SUCCESS: 'IRRF_REPORT_SUCCESS',
  IRRF_REPORT_ERROR: 'IRRF_REPORT_ERROR',

  IRRF_DOWNLOAD_REQUEST: 'IRRF_DOWNLOAD_REQUEST',
  IRRF_DOWNLOAD_SUCCESS: 'IRRF_DOWNLOAD_SUCCESS',
  IRRF_DOWNLOAD_ERROR: 'IRRF_DOWNLOAD_ERROR',

  IRRF_SELECT_ORIGIN: 'IRRF_SELECT_ORIGIN',
  IRRF_SELECT_TRANSACTION: 'IRRF_SELECT_TRANSACTION',

  IRRF_START_DATE: 'IRRF_START_DATE',
  IRRF_END_DATE: 'IRRF_END_DATE',

  IRFF_CLEAN_STORE: 'IRFF_CLEAN_STORE'
}

const getItemSelection = (state, payload) => {
  const newState = { ...state, selectedOrigin: payload }
  return newState
}

const getTransactionType = (state, payload) => {
  const newState = { ...state, transactionType: payload }
  return newState
}

const getOriginAccounts = (state, { data }) => {
  const newState = {
    ...state,
    isFetching: false,
    isFetched: true,
    success: true,
    data,
    origin: []
  }

  const accounts = data || []
  newState.origin = accounts.filter(item => item.accountType !== 'TD')
    .map(item => ({
      ...item,
      key: item.accountTypeId,
      value: item.description
    }
    ))

  if (newState.origin.length === 1) {
    return getItemSelection(newState, newState.origin[0])
  }

  return newState
}

const getReport = (state, payload) => {
  const newState = {
    ...state,
    isFetching: false,
    summary: {
      properties: [
        {
          key: 'settlementDate',
          value: 'Data de Movimentação'
        },
        {
          key: 'income',
          value: state.transactionType.key === 0 ? 'Rendimento' : 'Valor da Venda'
        },
        {
          key: 'tax',
          value: 'Imposto de Renda Retido'
        }
      ],
      data: []
    }
  }
  newState.summary.data = payload.map(tax => ({
    settlementDate: moment(tax.tradingSessionDate).format('DD/MM/YYYY'),
    income: moneyFormat(tax.income),
    tax: moneyFormat(tax.withHoldingTax)
  }))

  return newState
}

export const getIrrfAccount = () => ({
  type: ACTION_TYPES.IRRF_REQUEST
})

export const getIrrftReport = payload => ({
  type: ACTION_TYPES.IRRF_REPORT_REQUEST,
  payload
})

export const getIrrfDownload = payload => ({
  type: ACTION_TYPES.IRRF_DOWNLOAD_REQUEST,
  payload
})

export const setItemOrigin = payload => ({
  type: ACTION_TYPES.IRRF_SELECT_ORIGIN,
  payload
})

export const setTransactionType = payload => ({
  type: ACTION_TYPES.IRRF_SELECT_TRANSACTION,
  payload
})

export const setStartDate = payload => ({
  type: ACTION_TYPES.IRRF_START_DATE,
  payload
})

export const setEndDate = payload => ({
  type: ACTION_TYPES.IRRF_END_DATE,
  payload
})

export const cleanStore = payload => ({
  type: ACTION_TYPES.IRFF_CLEAN_STORE,
  payload
})

const irrf = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.IRRF_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.IRRF_SUCCESS:
      return getOriginAccounts(state, payload)
    case ACTION_TYPES.IRRF_ERROR:
      return {
        ...state,
        isFetched: true,
        error: true,
        data: payload
      }
    case ACTION_TYPES.IRRF_SELECT_ORIGIN:
      return getItemSelection(state, payload)
    case ACTION_TYPES.IRRF_SELECT_TRANSACTION:
      return getTransactionType(state, payload)
    case ACTION_TYPES.IRRF_REPORT_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.IRRF_REPORT_SUCCESS:
      return getReport(state, payload)
    case ACTION_TYPES.IRRF_REPORT_ERROR:
      return {
        ...state,
        isFetched: true,
        isFetching: false,
        error: true,
        summary: null,
        data: payload
      }
    case ACTION_TYPES.IRRF_DOWNLOAD_REQUEST:
      return {
        ...state,
        isFetchingDownload: true
      }
    case ACTION_TYPES.IRRF_DOWNLOAD_SUCCESS:
      saveAs(new Blob([payload.response.data], { type: payload.format }), payload.fileName)
      return {
        ...state,
        isFetchedDownload: true,
        isFetchingDownload: false,
        successDownload: true
      }
    case ACTION_TYPES.IRRF_DOWNLOAD_ERROR:
      return {
        ...state,
        isFetchedDownload: true,
        isFetchingDownload: false,
        errorDownload: true,
        data: payload
      }
    case ACTION_TYPES.IRRF_START_DATE:
      return {
        ...state,
        startDate: payload,
        endDate: null,
        displayStartDate: moment(payload).format('DD/MM/YYYY'),
        displayEndDate: null
      }
    case ACTION_TYPES.IRRF_END_DATE:
      return {
        ...state,
        endDate: payload,
        displayEndDate: moment(payload).format('DD/MM/YYYY')
      }
    case ACTION_TYPES.IRFF_CLEAN_STORE:
      return initialState
    default:
      return state
  }
}

export default irrf
